import React, { useMemo, useEffect } from 'react';
import { Button } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import moment from 'moment';

const BasicDets = (props) => {
    // Check if task description is mandatory from user settings (default to true as per requirement)
    const taskDescriptionIsMandatory = useMemo(() => {
        if (props.user && props.user.comp_settings) {
            // Look for feature_id 74 (Task Description Is Mandatory)
            const setting = props.user.comp_settings.find(setting => setting.feature_id === 74);
            console.log('Task Description Setting:', props.user.comp_settings);
            if (setting) {
                // If setting exists, use its value
                return setting.feature_value === 'true';
            }
        }
        // If no setting found, default to mandatory (true)
        return true;
    }, [props.user]);

    // let projList = props.projList.map((proj, indx) => <option key={indx} value={proj.pid}>{proj.pname}</option>)
    // console.log(props.projList);
    let unexpiredProjList = props.projList.filter(proj => {
        return (Date.parse(proj.end_date) > Date.now()) || (props.isSupport && (!proj.start_date || !proj.end_date || moment(proj.pro_starts_on).isSameOrBefore("1900-01-01") || moment(proj.pro_ends_on).isSameOrBefore("1900-01-01"))) 
    })
    
    // Filter by customer if customerPage is true and cus_id is provided
    if (props.customerPage && props.cus_id) {
        unexpiredProjList = unexpiredProjList.filter(proj => proj.cus_id === props.cus_id);
    }
    
    let projList = unexpiredProjList.map((proj, indx) => ({value:proj.pid ,title: proj.pname, cus_id: proj.cus_id}))
    
    // Auto-select project if there's only one option and field is empty
    useEffect(() => {
        if (!props.edit && projList.length === 1 && !props.formVals.tProject) {
            props.handleProjLoc(projList[0].value, 'tProject');
            props.handleProjChange(projList[0].cus_id, projList[0].value);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [projList.length, props.edit, props.formVals.tProject]);
    
    // let taskType = props.taskType.map((task, indx) => <option key={indx} value={task}>{task}</option>)
    let taskType = props.taskType.map((task, indx) => {return {value:task,title:task}})
    let empList = props.empList.map((emp, indx) => <option key={indx} value={emp.id}>{emp.employee_name}</option>)
    // checkboxes solution
    // let empList = props.empList.map((emp, indx) => 
    // <Form.Check 
    //     key={indx}
    //     type='checkbox' 
    //     label={emp.employee_name} 
    //     value={emp.employee_name}
    // >
    // </Form.Check>)
    let taskList = null
    if(!!props.edit){
        // taskList = props.taskList.filter(task => (+task.tas_pro_id === +props.formVals.tProject && task.tas_is_active === 0)).map((task, indx) => <option key={indx} value={task.tas_id}>{task.tas_title}</option>)
        taskList = props.taskList.filter(task => (+task.tas_pro_id === +props.formVals.tProject && task.tas_is_active === 0)).map((task, indx) => {return { value:task.tas_id,title:task.tas_title}})
    }else{
        // taskList = props.taskList.filter(task => (+task.tas_pro_id === +props.formVals.tProject && task.tas_is_active === 0)).map((task, indx) => <option key={indx} value={task.id}>{task.task_name}</option>)
        taskList = props.taskList.filter(task => (+task.tas_pro_id === +props.formVals.tProject && task.tas_is_active === 0)).map((task, indx) => {return {value:task.id,title:task.task_name}})
        taskList = [{value:"No Pre Req",title:'No Pre Req'},...taskList]
    }
    let toggleSelfRadio = false
    let toggleSelectWorkerRadio = false

    if (props.showSelectWorkerField) {
        toggleSelfRadio = false
        toggleSelectWorkerRadio = true
    } else {
        toggleSelfRadio = true
        toggleSelectWorkerRadio = false
    }

    // console.log('props: ', taskList)
    return (
        <div className=''>

            <TextField
                className={`my-3 w-100`}
                label="TASK TITLE"
                value={props.formVals.tTitle}
                onChange={(e) => props.handleBasicDetsChange(e)}
                inputProps={{ maxLength: 50 }}
                variant="outlined"
                id="tTitle"
                required
            />

            <TextField
                className={`my-3 w-100`}
                label="TASK DESCRIPTION"
                value={props.formVals.tDesc}
                onChange={(e) => props.handleBasicDetsChange(e)} 
                variant="outlined"
                id="tDesc"
                required={taskDescriptionIsMandatory}
                inputProps={{ maxLength: 1000 }}
            />

            <Autocomplete
                id="tProject"
                value={projList.find((pro)=> +pro.value === +props.formVals.tProject) || null}
                className={`my-3 w-100`}

                onChange={(e, newValue) => {
                    if (!newValue) {
                        // Handle deselection
                        props.handleProjLoc('', 'tProject');
                        props.handleProjChange('', '');
                        return;
                    }
                    let value = projList.find((proj) => proj.title === newValue.title);
                    console.log(value);
                    if (!!value) {
                        props.handleProjLoc(value.value, 'tProject');
                        props.handleProjChange(value.cus_id, value.value)
                    }
                    return;
                }}

                options={projList}
                getOptionLabel={(option) => option.title !== undefined ? option.title : option}
                isOptionEqualToValue={(option, value) => option.value === value.value}
                renderOption={(props, option) => <li {...props} key={option.value}>{option.title}</li>}
                renderInput={(params) => <TextField {...params} label="PROJECT *" variant="outlined" />}
            />

            <Autocomplete
                id="tPreReq"
                value={taskList.find((tas)=> tas.value === props.formVals.tPreReq) || null}
                className={`my-3 w-100`}
                onChange={(e, newValue)=> {
                    console.log(newValue)

                    let value = taskList.find((tas)=> tas.title === newValue.title)
                    console.log(value)
                    if(!!value){
                        props.handleProjLoc(value.value, 'tPreReq')
                    }
                    return
                    
                }}
                options={taskList}
                getOptionLabel={(option) => option.title}
                // style={{ width: 450 }}
                renderInput={(params) => <TextField {...params} label="TASK PREREQUISITE" variant="outlined" />}
            />

            <Autocomplete
                id="tType"
                value={taskType.find((type) => type.value === props.formVals.tType) || null}
                className={`my-3 w-100`}
                onChange={(e, newValue) => {
                    console.log(newValue);
                    if (newValue && newValue.title) {
                        props.handleBasicDetsChange({ target: { id: 'tType', value: newValue.title } });
                    } else {
                        props.handleBasicDetsChange({ target: { id: 'tType', value: ""} });
                    }
                }}
                options={taskType}
                getOptionLabel={(option) => option.title !== undefined ? option.title : option}
                // style={{ width: 450 }}
                renderInput={(params) => <TextField {...params} label="TYPE OF TASK *" variant="outlined" />}
            />

            {false && <div style={{ flex: 1 }}>
                <label>ASSIGNED TO</label><span><i style={{margin: 5,fontSize: '0.7rem'}} className="fas fa-asterisk text-danger"></i></span>
                <label>
                    <input
                        type="radio"
                        value="self"
                        onChange={(e) => props.handleRadioButtonToggle(e)}
                        checked={toggleSelfRadio}
                    /> self
                </label>
                <label>
                    <input
                        type="radio"
                        value="select worker"
                        onChange={(e) => props.handleRadioButtonToggle(e)}
                        checked={toggleSelectWorkerRadio}
                    /> Other (Select workers)
                </label>
            </div>}
            {props.showSelectWorkerField ? 
                <TextField
                    select
                    label="EMPLOYEE NAME"
                    id="tAssignedTo"
                    value={props.formVals.tAssignedTo}
                    onChange={(e) => props.handleBasicDetsChange({ target: { id: 'tAssignedTo', value: e.target.value } })}
                    variant="outlined"
                    required
                    fullWidth
                    className="my-3"
                    SelectProps={{ native: true }}
                >
                    <option value="">Select employee</option>
                    {empList}
                </TextField>
            : null
        }

            <Button className={`w-100`} variant="contained" type="button" onClick={() => props.onContinue("dateLocation")}>
                Continue
            </Button>
        </div>
    )
};

export default BasicDets;